import {
    countries
} from "countries-list";

export default {
    beforeCreate(context, inject) {
        var countryCodes = [];
        Object.keys(countries).forEach(function (k) {
            var codeNum = countries[k]["phone"].split(",");
            for (var i = 0, len = codeNum.length; i < len; i++) {
                countryCodes.push({
                    "label": countries[k]["emoji"] + "  " + "+" + codeNum[i] + "  " + countries[k]["native"],
                    "value": parseInt(codeNum[i])
                });
            }
        });
        // Inject httpClient eveywhere
        inject('countryCodes', countryCodes);

        // You can use it everywhere in your app:
        // - In UVue context: `context.$countryCodes`
        // - In your components: `this.$countryCodes`
        // - In your store actions: `this.$countryCodes`
    },
};